const display = display => ({
	display,
	position: 'relative',
	minWidth: 0,
	minHeight: 0
});

export default display;
